import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { MessageType } from '@medicalapp/shared-core';

@Component({
  selector: 'app-message-snackbar',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatSnackBarModule],
  templateUrl: './message-snackbar.component.html',
  styleUrl: './message-snackbar.component.scss',
})
export class MessageSnackbarComponent {
  snackBarRef = inject<MatSnackBarRef<MessageSnackbarComponent>>(MatSnackBarRef);
  data = inject(MAT_SNACK_BAR_DATA);

  get cssClass(): string {
    return 'snackbar-wrapper ' + (this.data?.panelClass || '');
  }

  get iconName(): string {
    switch (this.data?.type) {
      case MessageType.Success:
        return 'check_circle';
      case MessageType.Error:
        return 'error';
      case MessageType.Warning:
        return 'warning';
      case MessageType.Info:
        return 'info';
      default:
        return 'info';
    }
  }
}
